import styled from "styled-components";

const Style = styled.div`
  position: relative;
  height: 520px;

  .map {
    height: 100%;
    width: 100%;

    .leaflet-popup {
      top: -var(--size-lg) !important;
      left: var(--size-lg) !important;

      .leaflet-popup-tip-container {
        opacity: 0;
      }

      .leaflet-popup-close-button {
        display: none;
      }
    }
  }

  .left-cont {
    top: 0;
    left: 0;
    z-index: 800;
    padding: var(--size-lg);
    height: 100%;
    position: absolute;

    .daf-widget {
      min-width: 230px;
      max-width: 250px;

      .row-item {
        display: flex;
        flex-direction: column;
        padding: 9px 0px;
        border-bottom: 1px solid var(--border-color);

        label {
          font-size: 14px;
          font-weight: 500;
          color: var(--base-gray-70);
          margin-bottom: 4px;
        }

        span:not(.ant-tag) {
          font-size: 14px;
          color: var(--base-gray-90);
        }

        label, span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &:first-of-type {
          padding-top: 0px;
        }
        
        &:last-of-type {
          padding-bottom: 0px;
          border-bottom: 0px;
        }
      }
    }
  }
  .ant-tag {
      &.mineral {
        color: #52C41A;
        border-color: #B7EB8F;
        background: #F6FFED;
      }

      &.gold {
        color: #F5222D;
        border-color: #FFA39E;
        background: #FFF1F0;
      }

      &.tin, &.tantalum, &.tungsten, &.cobalt {
        color: #FA8C16;
        border-color: #FFD591;
        background: #FFF7E6;
      }
    }
`;

export default Style;
